import { memo, useState } from "react";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import {
  ListItemIcon,
  ListItemText,
} from "layouts/Flow Designer/components/Titlebar/components/TitlebarActions/StyledComponents";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const CopyButton = ({ value }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard
      .writeText(value)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 2000);
      })
      .catch((error) => {
        console.error("Error copying text to clipboard:", error);
      });
  };

  return (
    <ListItem sx={{ width: "80px" }}>
      <ListItemButton onClick={handleCopy} disabled={isCopied}>
        <ListItemIcon>
          {isCopied ? <CheckCircleIcon /> : <ContentCopyIcon />}
          <ListItemText
            primary={isCopied ? "Copied" : "Copy"}
            sx={{ alignItems: "center", display: "flex" }}
          />
        </ListItemIcon>
      </ListItemButton>
    </ListItem>
  );
};

export default memo(CopyButton);
